import React from 'react'
import Navbar from '../header/Navbar'
import Footer from '../footer/Footer'
import Login from '../games/signup/Login'

const Signup = () => {
  return (
    <div>
      <Navbar/>
      <Login/>
      <Footer/>
    </div>
  )
}

export default Signup